export default __webpack_public_path__ + "static/media/5.ec24bfdf.png";